export enum MappingSide {
  SOURCE = 'Source',
  TARGET = 'Target'
}
